module.exports = __webpack_public_path__ + "img/jsq.2821f080.png";